import { useQuery } from '@apollo/client';

import type { CurrencyPrecision, Get_Currency_PrecisionsQuery } from '../../../../apis/graphql/types';
import { GET_CURRENCY_PRECISIONS } from '../queries/getCurrencyPrecisions';

const NO_PRECISIONS: CurrencyPrecision[] = [];

/**
 * Every supported currency with the decimals Mission Control displays it with, read from the same
 * campaign-graphql field the Trafficking grid uses. Empty until the list loads or when it fails.
 */
export function useCurrencyPrecisions(): CurrencyPrecision[] {
  const { data } = useQuery<Get_Currency_PrecisionsQuery>(GET_CURRENCY_PRECISIONS);

  return data?.getCurrencyPrecisions ?? NO_PRECISIONS;
}
